import { createSelector } from 'reselect';

import { selectAllEventsInCart } from 'components/EventRegistration/redux/selectors';
import { fnBuildEventRegNavSteps, fnGetNextEventRegStep } from './helpers';

/**
 * Generates an array of all the event registration navigation steps
 */
export const selectEventRegNavSteps = createSelector(
  [selectAllEventsInCart, (state, bIsAuthenticated) => bIsAuthenticated],
  (aEventsInCart, bIsAuthenticated) =>
    fnBuildEventRegNavSteps(aEventsInCart, bIsAuthenticated)
);

/**
 * Returns the path for the next step in the event registration flow
 *
 * @param {string} sCurrentPath - window.location.pathname
 * @returns {string} - The path for the next step in the event registration flow
 *
 * @example
 * const fnNavigate = useNavigate();
 * const bIsAuthenticated = useIsUserAuthenticated();
 * const sNextStepUrl = useSelector((state) =>
 *   selectNextEventRegStep(state, window.location.pathname, bIsAuthenticated)
 * );
 * fnNavigate(sNextStepUrl);
 */
export const selectNextEventRegStep = createSelector(
  [
    (state, sCurrentPath, bIsAuthenticated) =>
      selectEventRegNavSteps(state, bIsAuthenticated),
    (state, sCurrentPath) => sCurrentPath,
  ],
  fnGetNextEventRegStep
);
